// extracted by mini-css-extract-plugin
export default {"userMenuWrapper":"UserMenu_userMenuWrapper__B34SA","button":"UserMenu_button__iGLir"};